import babyloanKoForm from './babyloan-ko-form/babyloan-ko-form.vue';
import babyloanKoFormOk from './babyloan-ko-form-ok/babyloan-ko-form-ok.vue';
import babyloanKoFormFailed from './babyloan-ko-form-failed/babyloan-ko-form-failed.vue';
import eventBus from '../../common/js/event-bus/event-bus';
import { mapState } from 'vuex';

export const MODAL_IDS = {
	BABYLOAN_KO_MODAL: 'babyloan_ko_modal',
	BABYLOAN_KO_OK_MODAL: 'babyloan_ko_ok_modal',
	BABYLOAN_KO_FAILED_MODAL: 'babyloan_ko_failed_modal',
	BABYLOAN_CALL_REQUEST_MODAL: 'babyloan-call-request'
};

export default {
	data: () => ({
		technicalError: false,
		showKoForm: false
	}),
	props: {
		version: Number,
		productId: Number,
		questionId: Number
	},
	components: {
		babyloanKoForm,
		babyloanKoFormOk,
		babyloanKoFormFailed
	},
	computed: {
		...mapState('babyloan', ['koFilter', 'amount', 'duration'])
	},
	methods: {
		onSubmitKoFilterForm(koFilterValue) {
			this.closePopup(MODAL_IDS.BABYLOAN_KO_MODAL);
			if (koFilterValue) {
				this.$openModal({}, MODAL_IDS.BABYLOAN_KO_OK_MODAL);
			} else {
				this.$openModal({}, MODAL_IDS.BABYLOAN_KO_FAILED_MODAL);
			}
			this.$store.dispatch('babyloan/setKoFilter', koFilterValue);
			eventBus.$emit('babyloanKoFinished', koFilterValue);
		},
		closePopup(modalId = MODAL_IDS.BABYLOAN_KO_MODAL) {
			this.$closeModal(modalId);
		},
		getOtherField() {
			let otherField = `KO: ${this.koFilter ? 'igen' : 'nem'}`;
			if (this.amount && this.duration) {
				const amount = this.$options.filters.number(this.amount);
				const duration = this.$options.filters.number(this.duration / 12);
				otherField += `, összeg ${amount}, futamidő ${duration} év.`;
			}
			return otherField;
		}
	},
	created() {
		this.$modalEventBus.$on('modal-opened', (modalId) => {
			if (modalId == MODAL_IDS.BABYLOAN_KO_MODAL) {
				this.$refs.form.resetKoForm();
			}
		});
		this.$modalEventBus.$on('modal-opened', (modalId) => {
			this.$nextTick(() => {
				if (modalId == MODAL_IDS.BABYLOAN_CALL_REQUEST_MODAL) {
					const event = new CustomEvent('call-request-blo-set-payload', { detail: this.getOtherField() });
					window.dispatchEvent(event);
				}
			});
		});
	}
};
